import { val } from '@uirouter/core';
import angular from 'angular';

angular.module('cloudX').directive('convertToNumber', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function(val) {
        if (typeof val === 'undefined' || val === null) return val;
        // if (val === '') return null;
        return parseInt(val, 10);
      });
      // ngModel.$formatters.push(function(val) {
      //   if (typeof val === 'undefined' || val === null) return val;
      //   return '' + val;
      // });
    },
  };
});
